import { useEffect, useMemo } from 'react'

let cssLoaded = false
let hljsPromise: Promise<typeof import('highlight.js')> | null = null

async function ensureHljsCss() {
  if (cssLoaded) return
  cssLoaded = true
  await import('highlight.js/styles/github.css')
}

const getHljs = async () => {
  if (!hljsPromise) {
    hljsPromise = import('highlight.js')
  }
  const module = await hljsPromise
  return module.default
}

const useHightlightCode = (markdown: string) => {
  const hasCodeBlock = useMemo(
    () => /```|~~~|^\s{4}\S|<code\b/i.test(markdown),
    [markdown],
  )
  useEffect(() => {
    if (!hasCodeBlock) return
    let isActive = true

    const highlight = async () => {
      await ensureHljsCss()
      const hljs = await getHljs()
      if (isActive) {
        hljs.highlightAll()
      }
    }

    void highlight()
    return () => {
      isActive = false
    }
  }, [hasCodeBlock, markdown])
}

export default useHightlightCode
